/*Custom JS File*/

/* Splide Carrousel*/

document.addEventListener('DOMContentLoaded', function () {
      new Splide('#video-carousel-pet-necklace', {
      type: 'loop',        // or 'slide' for no infinite loop
      perPage: 3,          // Show 3 videos at once
      perMove: 1,          // Move one slide per interaction
      gap: '1rem',         // Space between slides
      autoplay: false,     // Usually disabled for video slides
      lazyLoad: 'nearby',  // Helps with performance
      arrows: true,
      pagination: true,
      breakpoints: {
        768: {
          perPage: 2,
              }
        }
      }).mount();
});

/* The Mutt Studio - Bundle Tabs */

let tabHeader = document.getElementsByClassName("tab-header")[0];
let tabBody = document.getElementsByClassName("tab-body")[0];

if (tabHeader) {
    let tabsPane = tabHeader.getElementsByClassName("brushes");

    var activeClassID = tabHeader.getElementsByClassName('active');

    for (let i = 0; i < tabsPane.length; i++) {
      tabsPane[i].addEventListener("click", function () {
        tabsPane[i].setAttribute('data-action', 'add-to-cart');
          console.log(tabsPane[i].classList);

    if(tabsPane[0].classList.contains("active") || tabsPane[1].classList.contains("active") ){
      tabHeader.getElementsByClassName("active")[0].classList.remove("active");  
    }
    tabsPane[i].classList.add("active");  
  });
}
  
} else {
    //do nothing
}

// Currency Conversion

$(document).ready(function() {
    // Function to format the price (removing the currency symbol and formatting it correctly)
    function formatPrice(priceText) {
        // Remove any non-numeric characters like the dollar symbol and spaces
        let price = priceText.replace(/[^0-9.,]/g, '').trim();
        // Replace commas with dots if necessary for proper decimal notation
        price = price.replace(',', '.');
        return parseFloat(price);
    }

    // Function to fetch live conversion rates from the API
    function fetchConversionRates(baseCurrency, callback) {
        $.ajax({
            url: `https://api.exchangerate-api.com/v4/latest/${baseCurrency}`,  // API URL
            method: 'GET',
            success: function(data) {
                callback(data.rates);  // Pass conversion rates to the callback
            },
            error: function() {
                console.log("Error fetching conversion rates.");
            }
        });
    }

    // Function to manually convert and update prices in the specified elements
    function convertAndUpdatePrice(selector, targetCurrency, conversionRates) {
        if (!conversionRates[targetCurrency]) {
            console.log("Conversion rate for target currency not available.");
            return;
        }

        // Loop through each element that matches the selector (e.g., .money-bro)
        $(selector).each(function() {
            var priceText = $(this).text().trim();
            var price = formatPrice(priceText);  // Convert the price text to a float

            // Apply the conversion rate
            var convertedPrice = price * conversionRates[targetCurrency];

            // Format the converted price with the appropriate currency symbol
            var formattedConvertedPrice = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: targetCurrency
            }).format(convertedPrice);

            // Update the span with the converted price
            $(this).text(formattedConvertedPrice);
        });
    }

    // Fetch conversion rates and apply to .money-bro
    fetchConversionRates('USD', function(rates) {  // Assuming base currency is USD
        convertAndUpdatePrice('.money-bro', 'GBP', rates);  // Change 'EUR' to desired currency
    });
});